module.exports = __webpack_public_path__ + "static/media/female.ef07168d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/question-images/female.jpg
// module id = 113
// module chunks = 0